var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Treeable } from '../treeable/shared/treeable.model';
/**
 * Model object for the FileAsset Object in dotCMS.
 */
var File = (function (_super) {
    __extends(File, _super);
    function File() {
        var _this = _super.call(this) || this;
        _this.displayType = 'File';
        return _this;
    }
    /**
     * Convenience method to check the mimetype and so if it starts with image
     * @returns {boolean}
     */
    File.prototype.isImage = function () {
        return this.mimeType.startsWith('image');
    };
    return File;
}(Treeable));
export { File };
//# sourceMappingURL=file.model.js.map